import {
  LOG_IN_PENDING,
  LOG_IN_SUCCESS,
  LOG_IN_FAILED,
  SIGN_OUT_SUCCESS,
  SIGN_OUT_FAILED,
  VERIFY_TOKEN_PENDING,
  VERIFY_TOKEN_SUCCESS,
  VERIFY_TOKEN_FAILED,
} from '../actionTypes';

const authInitialState = {
  logInError: null,
  verifyTokenError: null,
  logInPending: false,
  verifyTokenPending: true,
  isAuthenticated: false,
};

const authReducer =  (state = authInitialState, { type = '', payload = {} }) => {
  switch (type) {
    case LOG_IN_PENDING: {
      return {
        ...state,
        logInPending: true,
        logInError: false,
        isAuthenticated: false,
      };
    }

    case LOG_IN_SUCCESS: {
      return {
        ...state,
        logInError: false,
        logInPending: false,
        isAuthenticated: true,
        adminData: payload,
      };
    }

    case LOG_IN_FAILED: {
      return {
        ...state,
        logInPending: false,
        isAuthenticated: false,
        logInError: payload,
      };
    }

    case SIGN_OUT_SUCCESS: {
      return {
        ...state,
        signOutError: false,
        isAuthenticated: false,
        token: null,
      };
    }

    case SIGN_OUT_FAILED: {
      return {
        ...state,
        signOutError: true,
      };
    }

    case VERIFY_TOKEN_PENDING: {
      return {
        ...state,
        verifyTokenPending: true,
      };
    }

    case VERIFY_TOKEN_SUCCESS: {
      return {
        ...state,
        verifyTokenPending: false,
        isAuthenticated: true,
        user: payload,
      };
    }

    case VERIFY_TOKEN_FAILED: {
      return {
        ...state,
        verifyTokenPending: false,
        verifyTokenError: true,
      };
    }

    default:
      return state;
  }
};

export default authReducer